module.exports = __webpack_public_path__ + "img/concrete-side.7c84269c.png";